import { HOTEL_DETAIL_TAB_MENU_LIST } from '@constants/constants';
import { TabMenu } from '@shared/searchBar/tabMenu';

type TabMenuOptions = {
  hasEvents: boolean;
  hasFeatures: boolean;
};

export const getHotelDetailTabMenuList = ({
  hasEvents,
  hasFeatures,
}: TabMenuOptions): TabMenu[] => {
  let base = HOTEL_DETAIL_TAB_MENU_LIST.slice();

  if (!hasFeatures) {
    base = base.filter((t) => t.key !== 'features');
  }

  if (hasEvents) {
    const result: TabMenu[] = [];
    base.forEach((tab) => {
      if (tab.key === 'overview') {
        result.push(tab);
        result.push({ id: 0, key: 'events', text: 'Otel Etkinlikleri' });
      } else {
        result.push(tab);
      }
    });
    base = result;
  }

  return base.map((t, i) => ({ ...t, id: i + 1 }));
};

export type HotelDetailTabHandlers = {
  overview: () => void;
  events?: () => void;
  features: () => void;
  rooms: () => void;
  location: () => void;
  scoring: () => void;
  about: () => void;
};

export const getHotelDetailTabChangeHandler = (
  tabList: TabMenu[],
  handlers: HotelDetailTabHandlers
) => {
  return (id: number) => {
    const tab = tabList.find((t) => t.id === id);
    switch (tab?.key) {
      case 'overview':
        return handlers.overview();
      case 'events':
        return handlers.events?.();
      case 'features':
        return handlers.features();
      case 'rooms':
        return handlers.rooms();
      case 'location':
        return handlers.location();
      case 'comments':
        return handlers.scoring();
      case 'informations':
        return handlers.about();
      default:
        return handlers.overview();
    }
  };
};
